"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickOrderFormResultRow = void 0;
var _mui = require("@ori-ui/mui");
var _ProductShade = require("./ProductShade");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/naming-convention -- x */

const Root = (0, _mui.styled)('span')(({
  ownerState: {
    isHighlighted
  },
  theme
}) => ({
  alignItems: 'center',
  color: theme.palette.grey[900],
  cursor: 'pointer',
  display: 'flex',
  fontWeight: isHighlighted ? 'bold' : 'normal',
  padding: theme.spacing(2, 0)
}));
const Description = (0, _mui.styled)('span')(({
  theme
}) => ({
  flexGrow: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 'calc(100% - 105px)',
  [theme.breakpoints.up('sm')]: {
    width: 'calc(100% - 155px)'
  }
}));
const ShadeName = (0, _mui.styled)('span')(({
  theme
}) => ({
  color: theme.palette.grey.A400,
  flexGrow: 1,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(2),
  overflow: 'hidden',
  textAlign: 'left',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: 70,
  [theme.breakpoints.up('sm')]: {
    width: 120
  }
}));
const QuickOrderFormResultRow = ({
  inputValue,
  isHighlighted,
  item,
  ...props
}) => {
  const regex = `^(${inputValue})`;
  const highlightedText = (item.description ?? '').replace(new RegExp(regex), '<strong>$1</strong>');
  const ownerState = {
    isHighlighted
  };
  const {
    color: colorName,
    colorHexCode,
    colorSrc: colorImageSrc
  } = item;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ownerState: ownerState,
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Description, {
      dangerouslySetInnerHTML: {
        __html: highlightedText
      }
    }), colorName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ShadeName, {
      children: colorName
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductShade.ProductShade, {
      colorHexCode: colorHexCode ?? null,
      colorImageSrc: colorImageSrc ?? null
    })]
  });
};
exports.QuickOrderFormResultRow = QuickOrderFormResultRow;